import { Layer } from "../../../types/Layer";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

interface LicenceLayerAccessProps {
  allLayers: Layer[];
  availableLayers: Layer[];
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LicenceLayerAccess = ({
  allLayers,
  availableLayers,
}: LicenceLayerAccessProps) => {
  return (
    <Container>
      {allLayers.map((layer) => (
        <Item key={layer.id}>
          <span>{layer.displayName}</span>
          {availableLayers.map((x) => x.id).includes(layer.id) ? (
            <FontAwesomeIcon icon={faCheck} style={{ color: "green" }} />
          ) : (
            <FontAwesomeIcon icon={faTimes} style={{ color: "red" }} />
          )}
        </Item>
      ))}
    </Container>
  );
};

export default LicenceLayerAccess;
